<template>
  <v-card class="mt-3 pa-3" style="margin: 15px">
    <form class="formulario" @submit.prevent="gerarRelatorio">
      <div>
        <Select label="Ano" :options="optionsAno" v-model.number="aaletivo" :v="$v.aaletivo" :disabled="loading" @change="limparSelects()" />

        <select-ajax
          label="Turma"
          :disabled="loading || aaletivo == '-1'"
          rota='ei/turma/por-perfil-ano-disciplina-periodo-professor'
          :params="{ cdtipesc, cdescola, cdpessoal, cdmatric, aaletivo, cddiscipl: '', cdpessoalprofessor: '', cdmatricprofessor: '', cdpravadi, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          contador
          ref="turmas"
          chave="cdturma"
          :valor="(item) => `${item.nmturma} ${item.horario ? ' - ' + item.horario : ''}`"
          v-model="cdturma"
          :v="$v.cdturma"
          >
        </select-ajax>

        <select-ajax
          label="Período Avaliativo"
          :disabled="loading || cdturma == ''"
          rota='ei/periodo-avaliativo/periodos-por-coordenador-ano-turma-disciplina-professor'
          :params="{ aaletivo, cdtipesc, cdescola, cdpessoal, cdmatric, cdturma, cddiscipl:'', cdpessoalprofessor:'', cdmatricprofessor:'', identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          contador
          opcaoTodos="Todos"
          ref="periodos"
          chave="cdpravadi"
          valor="dspravadi"
          v-model="cdpravadi"
          :v="$v.cdpravadi">
        </select-ajax>

      </div>

      <div style="text-align: right">
        <v-btn width="120px" class="rounded-sm font-weight-regular" type="submit" color="teal" style="color:white" :disabled="loading" :loading="loadingGerar">
          <v-icon size="23" left dark>picture_as_pdf</v-icon>
          Gerar
        </v-btn>
      </div>

    </form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, integer, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import frequenciaDiaReport from '@/reports/professor/registroFrequenciaDiaReport';
import SelectAjax from '@/components/SelectAjax'

const ProfessorReportsRepository = RepositoryFactory.get('professorReports');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'DemonstrativoFrequenciaDia',
  components: {
    SelectAjax
  },
  data() {
    return {
      aaletivo: '',
      cdpessoal: '',
      cdmatric: '',
      cdtipesc: '',
      cdescola: '',
      cdturma: '',
      cdpravadi: '',
      loading: false,
      loadingGerar: false,
    };
  },
  validations() {
    return {
      aaletivo: { required, integer },
      cdtipesc: { required, integer },
      cdescola: { required, integer },
      cdpessoal: { required, integer },
      cdmatric: { required, integer },
      cdturma: { required, maxLength: maxLength(4) },
      cdpravadi: { required, maxLength: maxLength(2) },
    };
  },
  async created() {
    this.aaletivo = this.getAnoAtualServidor;
    this.cdtipesc = this.school.cdtipesc;
    this.cdescola = this.school.cdescola;
    this.cdpessoal = this.userProfessor.cdpessoal;
    this.cdmatric = this.userProfessor.cdmatric;
  },
  methods: {
    async gerarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      this.loadingGerar = true;

      try {

        const { data } = await ProfessorReportsRepository.getDemonstrativoFrequenciaDia({
          aaletivo: this.aaletivo,
          cdtipesc: this.cdtipesc,
          cdescola: this.cdescola,
          cdpessoal: this.cdpessoal,
          cdmatric: this.cdmatric,
          cdturma: this.cdturma,
          cdpravadi: (this.cdpravadi == '-1') ? null : this.cdpravadi,

        });

        let a = this.$refs.turmas.obterlista();

        const filtros = {
            aaletivo: this.aaletivo,
            cdtipesc: this.cdtipesc,
            cdescola: this.cdescola,
            cdpessoal: this.cdpessoal,
            cdmatric: this.cdmatric,
            nmfuncion: this.username,
            nmescola: this.school.nmescola,
            identificadorperfil: this.userDadosPerfilAtual.identificadorperfil,
            nmturma: this.$refs.turmas.obterlista().filter( turma => turma.key == this.cdturma )[0].value,
            dspravadi: this.$refs.periodos.obterlista().filter( periodo => periodo.key == this.cdpravadi )[0].value,
            periodos: this.$refs.periodos.obterlista().filter(p => this.cdpravadi == -1 ? p.key != -1 : p.key == this.cdpravadi).map(p => p)
        };

        const docDefinition = await frequenciaDiaReport({
          date: data.results.date,
          time: data.results.time,
          filtros,
          aulas: data.results.aulas,
          disciplinas: data.results.disciplinas,
          data: data.results.data,
          professores: data.results.professores
        });

        pdfMake.createPdf(docDefinition).download(docDefinition.info.title);

      } finally {
        this.loadingGerar = false;
      }
    },

    limparSelects() {
      this.$refs.turmas.limpar();
      this.$refs.periodos.limpar();
    }
  },
  watch: {
    'cdturma': function() {
      this.$refs.periodos.limpar();
    }
  },
  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username', 'userDadosPerfilAtual']),
    optionsAno() {
      if(!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [];
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
}
</script>

<style lang="scss">
@media only screen and (min-width: 700.1px){
  .formulario .select-ajax {
    .selecionado { width: 60%; }
    .select-ajax-lista { width: 60%; }
  }
}
</style>
